import type { StateCreator } from "zustand";
import type { RunControlState } from "./index";

export interface BreakpointsSlice {
  breakpoints: Set<string>;
  addBreakpoints: (ids: string[]) => void;
  removeBreakpointLocal: (id: string) => void;
  toggleBreakpointLocal: (id: string) => void;
  clearBreakpoints: () => void;
}

export const createBreakpointsSlice: StateCreator<
  RunControlState,
  [["zustand/immer", never], ["zustand/subscribeWithSelector", never]],
  [],
  BreakpointsSlice
> = (set) => ({
  breakpoints: new Set(),

  addBreakpoints: (ids) =>
    set((state) => {
      ids.forEach((id) => state.breakpoints.add(id));
    }),

  removeBreakpointLocal: (id) =>
    set((state) => {
      state.breakpoints.delete(id);
    }),

  toggleBreakpointLocal: (id) =>
    set((state) => {
      if (state.breakpoints.has(id)) {
        state.breakpoints.delete(id);
      } else {
        state.breakpoints.add(id);
      }
    }),

  clearBreakpoints: () =>
    set((state) => {
      state.breakpoints = new Set();
    }),
});
